import { useCallback } from "react";
import { useMutation, useQueryClient } from "react-query";
import { Api } from "src/apis/helpers/configs/api";
import { StandardsService } from "src/apis/services/standards/standardsService";
import { StandardsDto } from "src/data/models/standardsDtos/standardsDto.interface";
import { container } from "tsyringe";

export const useEditStandards = () => {
    const standardsService = container.resolve(StandardsService);
    const queryClient = useQueryClient();
    const toggleEditUser = useCallback(
        (data, variables, context) => {
            let tempData = queryClient.getQueryData<Array<StandardsDto>>([Api.Standards.getStandards]);
            const newData = [...tempData] ;
            const findIndex = newData.findIndex(x=>x.standardId === data.standardId) ;
            newData[findIndex] = data;
            tempData = newData;
            queryClient.setQueryData([Api.Standards.getStandards],tempData )
        },
        [],
    );
    return useMutation({
        mutationFn: (data: StandardsDto) => {
            return standardsService.editStandards(data);
        },
        onSuccess: toggleEditUser
    })

}
